import { DsFormTypeEnum } from '../../enums/ds-forms.enum';
import { DsFormField } from './ds-form-field.class';
import { DsFormSectionInterface } from '../../interfaces/form-fields/ds-form-section.interface';

export class DsFormSection extends DsFormField {
  /**
   *
   */
  level?: 1 | 2 | 3 | 4 | 5;

  /**
   * Creates an instance of DsFormSection.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsFormSectionInterface) {
    super(jsonData);
    this.type = DsFormTypeEnum.SECTION;
    this.level = jsonData.level || 1;
  }
}
